"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const badge_module_scss_1 = __importDefault(require("./badge.module.scss"));
const Badge = (_a) => {
    var { size = "small", emphasis = "default", type = "solid", children, theme = "core" } = _a, props = __rest(_a, ["size", "emphasis", "type", "children", "theme"]);
    return (react_1.default.createElement("div", Object.assign({}, props, { className: `${badge_module_scss_1.default.badge} ${props.className}`, "data-size": size, "data-emphasis": emphasis, "data-type": type, "data-theme": theme }), children));
};
exports.default = Badge;
//# sourceMappingURL=badge.js.map